import Plausible from 'plausible-tracker'
import { TRACKING_ENABLED, PLAUSIBLE_DOMAIN as domain } from '../config.js';

const { trackPageview, trackEvent } = Plausible({
  trackLocalhost: TRACKING_ENABLED || false,
  domain: domain || 'payetachargementale.com',
});

export { trackPageview, trackEvent };
